import { createStore } from "easy-peasy"
import model from "./model/Index"

const store = createStore(model)

export default store;